import React from 'react';

import router from 'next/router';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './Card.module.scss';

const Card = ({ pool }: any) => {
    const { t } = useTranslateLpc('lpc-solidarity-page');

    const goToPot = () => {
        router.push(getRoute(ROUTE.LPC.POT.POT, pool.uniq));
    };

    return (
        <div className={css.card} onClick={goToPot}>
            <div
                className={css.card__image}
                style={{
                    backgroundImage: `url(${pool.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            ></div>
            <div className={css.card__content}>
                <div className={css.card__content__title}>
                    <Text
                        variant={'caption_semi_bold'}
                        color={'black-gray'}
                        customClass={css.card__content__title__truncated}
                    >
                        {pool.title}
                    </Text>
                </div>
                <div>
                    <div className={css.card__content__stats}>
                        <div className={css.card__content__stats__amount}>
                            <Text
                                variant={'caption_semi_bold'}
                                color={'brand-primary'}
                                customClass={css.card__content__stats__amount__number}
                            >
                                {`${pool.contributionAmount.toFixed(2)}€`}
                            </Text>
                            <Text
                                variant={'caption_02'}
                                color={'light-black-gray'}
                                customClass={css.card__content__stats__amount__text}
                            >
                                {t('pools.harvested')}
                            </Text>
                        </div>
                        <div className={css.card__content__stats__participants}>
                            <Text
                                variant={'caption_semi_bold'}
                                color={'black-gray'}
                                customClass={css.card__content__stats__participants__number}
                            >
                                {`${pool.participationNumber}`}
                            </Text>
                            <Text
                                variant={'caption_02'}
                                color={'light-black-gray'}
                                customClass={css.card__content__stats__participants__text}
                            >
                                {t('pools.participants')}
                            </Text>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Card;
